module.exports = __webpack_public_path__ + "img/ZagrosTowers.57063493.png";